// Hooks
//import useScript from "../Hooks/useScript";

const Chatbot = () => {
    /*    useScript('https://henkel-cognigy.s3.eu-central-1.amazonaws.com/lp/fr/atc_fr/src/webchat.js');
        useScript('https://henkel-cognigy.s3.eu-central-1.amazonaws.com/lp/fr/atc_fr/src/atc_webchat.js');*/
    return null;
};

export default Chatbot;